namespace TabAurous.OMS {
    export interface CountriesMasterRow {
        Id?: number;
        ShortName?: string;
        Name?: string;
        Nationality?: string;
        Phonecode?: number;
    }

    export namespace CountriesMasterRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShortName';
        export const localTextPrefix = 'OMS.CountriesMaster';
        export const lookupKey = 'OMS.CountriesMaster';

        export function getLookup(): Q.Lookup<CountriesMasterRow> {
            return Q.getLookup<CountriesMasterRow>('OMS.CountriesMaster');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShortName = "ShortName",
            Name = "Name",
            Nationality = "Nationality",
            Phonecode = "Phonecode"
        }
    }
}
